export default "__VITE_ASSET__BEiikEGo__"